import { DataSource, DataSourceExecutionEvent, Label, Layout, SlideoutDecorator, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutPayHistory } from "./autogen/AutogenLayoutPayHistory";
import { Currency, ModelRow } from "@mcleod/core";
import { CommonTooltips } from "@mcleod/common";

const DEDUCT_TYPE_EARNING: string = 'E';
export class PayHistory extends AutogenLayoutPayHistory {

    private _driverId: string;

    constructor(props?) {
        super(props);
        this._driverId = props?.driverId
    }

    static showSlideout(driverId:string) {
        const layout = Layout.getLayout("lme/dispatch/PayHistory",{driverId: driverId} as any) as PayHistory;
        new SlideoutDecorator({
            layout: layout,
            width: window.innerWidth * .75,
            fillVerticalSpace: true,
            displayOverlay: true,
            overlayProps: { greyedBackground: true },
            title: "Pay History",
            layoutLoadListeners: () => {
                layout.sourceDriverInfo.search({"id": driverId}).then((result)=>{
                    const row = result.modelRows[0] as ModelRow
                    const payeeId = row.get("payee_id");
                    if(payeeId){
                        layout.sourceAllPayees.search({"id": payeeId});
                        layout.sourceDrsPayrollHist.maxResults=2;
                        layout.sourceDrsPayrollHist.search({"payee_id": driverId}).then((result)=>{
                            const rows = result.modelRows;
                            layout.setPayrollFields(rows);
                        });
                    }
                });
                layout.sourceAdvanceInfo.orderBy=[{field:"date",sort:"desc"}];
                layout.sourceAdvanceInfo.search({"driver_id": driverId});

                layout.sourceDrsPendingDeduct.orderBy=[{field: "transaction_date", sort: "desc"}];
                layout.sourceDrsPendingDeduct.search({"payee_id": driverId})
            },
        });

    }

    setPayrollFields(rows){
        const row1 = rows[0] as ModelRow;
        const row2 = rows[1] as ModelRow;

        this.textboxCheckNo1.displayData(row1,null,0);
        this.textboxCheckNo2.displayData(row2,null,0);

        this.textboxDate1.displayData(row1,null,0);
        this.textboxDate2.displayData(row2,null,0);

        this.textboxGross1.displayData(row1,null,0);
        this.textboxGross1.printable = false;
        this.textboxGross1.printable = true;
        this.textboxGross2.displayData(row2,null,0);
        this.textboxGross2.printable = false;
        this.textboxGross2.printable = true;

    }

    tablePendingDeductionsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.target as TableRow;
        const modelRow = tableRow.data;
        const labelDeductCodeShortDesc = tableRow.findComponentById("labelDeductCodeShortDesc") as Label;
        CommonTooltips.setTooltipContentLayout(labelDeductCodeShortDesc,
            modelRow.get("id"), "lme/dispatch/PendingDeductionQuickInfo", { width: 210 });
    }

    sourceDriverInfoAfterExecution(event: DataSourceExecutionEvent) {
        if (this.sourceDriverInfo.activeRow?.get("contact.phone")) {
            this.labelPhone.visible = true;
        } else {
            this.labelCellPhone.visible = true;
        }

        if(this.sourceDriverInfo.activeRow?.get("first_name")){
            this.labelFirstName.visible = true;
        }

        CommonTooltips.setTooltipContentLayout(this.panelName,
            this.sourceDriverInfo.activeRow?.get("id"), "lme/dispatch/asset/DriverQuickInfo");
        CommonTooltips.setTooltipContentLayout(this.labelPayeeName,
            this.sourceDriverInfo.activeRow?.get("payee_id"), "lme/dispatch/PayeeQuickInfo", { width: 210});
    }


    sourceAllPayeesAfterExecution(event: DataSourceExecutionEvent) {
        if (this.sourceAllPayees.activeRow?.get("address2")) {
            this.labelAddress2.visible = true;
        }

        if (this.sourceAllPayees.activeRow?.get("contact.phone")) {
            this.labelPayeePhone.visible = true;
        } else {
            this.labelPayeeMobilePhone.visible = true;
        }
    }

    sourceAdvanceInfoAfterExecution(event: DataSourceExecutionEvent) {        
        const advanceTotal: Currency = this.sumDatasourceCurrency(this.sourceAdvanceInfo, "amount");
        this.labelAdvanceTotal.text = advanceTotal.toString();
    }

    sourceDrsPendingDeductAfterExecution(event: DataSourceExecutionEvent) {
        const deductionTotal = 
        this.sourceDrsPendingDeduct.data.map(row => 
            DEDUCT_TYPE_EARNING == row.get("deduction_type","")
                ? -row.getCurrency("amount").amount
                : row.getCurrency("amount").amount
        ).reduce((sum, next) => sum + next, 0);
        const currencyDeductionTotal = Currency.createCurrencyWithDefaults(deductionTotal);
        this.labelPendingDeductionsTotal.text = currencyDeductionTotal.toString();
    }

    private sumDatasourceCurrency(source: DataSource, field: string|number|symbol): Currency {
        const currencyValue = 
            source.data.map(row => row.getCurrency(field).amount)
            .reduce((sum, next) => sum + next, 0);
        return Currency.createCurrencyWithDefaults(currencyValue);
    }


    get driverId(): string {
        return this._driverId;
    }

    set driverId(value: string) {
        this._driverId = value;
    }
}
